<template>
  <v-container :fluid="true" :key="update_key_invoice">
    <v-row>
      <v-col class="xs-6" cols="6">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Pay.CreateInvoice.Workpackage.Title')}}</v-toolbar-title>
            <v-btn @click="createInvoicePreviewClick()">
              {{$t('Project.Settings.Pay.CreateInvoice.Workpackage.Button')}}
            </v-btn>
          </v-toolbar>
          <v-row>
            <v-col xs12 cols="12" class="invoice-setting-default-height">
              <div class="wp-list">
                <div
                  v-for="(wp_list, index) of getInvoiceableTWorkPackages"
                  :key="index"
                  >
                  <div class="date-circle-wrapper">
                    <DateCircle
                      @click.native="selectDeselectTWPs(wp_list)"
                      :value="[wp_list[0].first_day, wp_list[0].last_day]"
                    />
                  </div>
                  <WorkPackage
                    v-for="work_package in wp_list"
                    :key="work_package.id"
                    :color="`${work_package.color} ${work_package.color.includes('lighten') || work_package.color.includes('darken')? '':'lighten-1'}`"
                    :token="work_package.token"
                    :icon="work_package.icon"
                    :zoom="1"
                    class="cursor-pointer"
                    @click.native="selectDeselectTWPs([work_package])"
                    >
                    <template #workpackage>
                      <StandardBadge
                      :show_icon_cond="isSelectedTWP(work_package)"
                      show_icon="done"
                      color="white"
                      content_color="black"
                      />
                    </template>
                  </WorkPackage>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Pay.CreateInvoice.Project.Title')}}</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col xs12 cols="12" class="invoice-setting-default-height">

              <div class="mini-invoice-row">
                <MiniInvoice
                v-for="invoice in getProjectOwnerInvoices($route.params.project_id)"
                :key="invoice.id"
                :invoice="invoice"
                class="my-mini-invoice"
                @click.native="setCurrentInvoice(invoice)"
                />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col v-if="(getInvoicePreview.iwork_packages.length && show_preview) || (current_invoice && !show_preview)" class="xs-6" cols="6">
        <v-card v-if="show_preview">
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Pay.CreateInvoice.PreviewTitle')}}</v-toolbar-title>
            <v-btn @click="createInvoice(getInvoicePreview), update_key_invoice++">
              <v-icon>money</v-icon>
              {{$t('Project.Settings.Pay.CreateInvoice.Button')}}
            </v-btn>
          </v-toolbar>
          <v-row>
            <v-col xs12 class="members-setting-default-height">
              <Invoice id="takting_invoice" :preview="true">
                <template #invoice_to_address>
                  <b>{{ getInvoicePreview.business.name}}</b> <br>
                  {{ getInvoicePreview.address.street }} {{ getInvoicePreview.address.building_number }} <br>
                  {{ getInvoicePreview.address.zip_code }} {{ getInvoicePreview.address.city }} <br>
                  {{ getInvoicePreview.address.country }} <br>
                  VAT {{ getInvoicePreview.address.custom_information }}
                </template>
                <template #invoice_from_address>
                  <b>Seller</b>
                  <div class="from-address-row">
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.CustomInfo')"
                      width="100%"
                      :value="from_address.custom_information"
                      @changeValue="from_address.custom_information = $event"
                      />
                  </div>
                  <div class="from-address-row">
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.Street')"
                      width="50%"
                      :value="from_address.street"
                      @changeValue="from_address.street = $event"
                      />
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.BuildingNumber')"
                      width="50%"
                      :value="from_address.building_number"
                      @changeValue="from_address.building_number = $event"
                      />
                  </div>
                  <div class="from-address-row">
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.ZipCode')"
                      width="30%"
                      :value="from_address.zip_code"
                      @changeValue="from_address.zip_code = $event"
                    />
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.City')"
                      width="70%"
                      :value="from_address.city"
                      @changeValue="from_address.city = $event"
                    />
                  </div>
                  <div class="from-address-row">
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.Country')"
                      width="100%"
                      :value="from_address.country"
                      @changeValue="from_address.country = $event"
                    />
                  </div>
                  <div class="from-address-row">
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.SellerVat')"
                      width="100%"
                      :value="meta_info.seller_vat"
                      @changeValue="meta_info.seller_vat = $event"
                    />
                  </div>
                </template>
                <template #invoice_meta_info>
                  <div class="meta-info-row">
                    Project number:
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.ProjectNumber')"
                      width="50%"
                      :value="meta_info.project_number"
                      @changeValue="meta_info.project_number = $event"
                    />
                  </div>
                  <div class="meta-info-row">
                    Contract number:
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.ContractNumber')"
                      width="50%"
                      :value="meta_info.contract_number"
                      @changeValue="meta_info.contract_number = $event"
                    />
                  </div>
                  <div class="meta-info-row">
                    <div>Date:</div>
                    <div>{{ new Date().toDateString() }}</div>
                  </div>
                  <div class="meta-info-row">
                    Invoice number:
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.InvoiceNumber')"
                      width="50%"
                      :value="meta_info.invoice_number"
                      @changeValue="meta_info.invoice_number = $event"
                    />
                  </div>
                  <div class="meta-info-row">
                    Invoice due date:
                    <StandardDataField
                      :placeholder="$t('Project.Settings.Pay.CreateInvoice.InvoiceDueDate')"
                      width="50%"
                      :value="meta_info.invoice_due_date"
                      @changeValue="meta_info.invoice_due_date = $event"
                    />
                  </div>
                </template>
                <template #invoice_headline>
                  {{$t('Project.Settings.Pay.CreateInvoice.Invoice')}} {{ getProject($route.params.project_id).name }}
                </template>
                <!-- <template #invoice_qr_info>
                  <div class="qr-code"> </div>
                </template> -->
                <template #invoice_content>
                  <InvoiceContentEntry
                    v-for="invoice_wp in getInvoicePreview.iwork_packages"
                    :key="'invoice_wp' + invoice_wp.id"
                    :work_package="invoice_wp"
                    :preview="true"
                    >
                    <template #invoice_content_entry_note>
                      {{$t('Project.Settings.Pay.Note')}}
                    </template>
                  </InvoiceContentEntry>
                  <InvoiceContentEntry
                    :work_package="getSumWP()"
                    :preview="true"
                  >
                  <template #invoice_content_entry_note>
                    {{$t('Project.Settings.Pay.Note')}}
                  </template>
                </InvoiceContentEntry>
                </template>
                <template #invoice_content_footer>
                  {{$t('Project.Settings.Pay.InvoiceFooter[0]')}}
                  <br> <br>
                  {{$t('Project.Settings.Pay.InvoiceFooter[1]')}}
                </template>
                <template #invoice_signature>
                  {{ getUser.first_name + ' ' + getUser.last_name }}
                </template>
                <template #invoice_footer_upper_row>
                  <textarea style="width: 100%" class="t-rounded t-shadow" v-model="footer_upper_row">
                  </textarea>
                </template>
                <template #invoice_left_footer>
                  <textarea class="t-rounded t-shadow" v-model="footer_left">
                  </textarea>
                </template>
                <template #invoice_middle_footer>
                  <textarea class="t-rounded t-shadow" v-model="footer_middle">
                  </textarea>
                </template>
                <template #invoice_right_footer>
                  <textarea class="t-rounded t-shadow" v-model="footer_right">
                  </textarea>
                </template>
              </Invoice>
            </v-col>
          </v-row>
        </v-card>
        <v-card v-else>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">{{$t('Project.Settings.Pay.CreateInvoice.PrintTitle')}}</v-toolbar-title>
            <v-btn @click="exportInvoice()">
              <v-icon>print</v-icon>
              {{$t('Project.Settings.Pay.CreateInvoice.PrintButton')}}
            </v-btn>
          </v-toolbar>
          <v-row>
            <v-col xs12 class="members-setting-default-height">
              <Invoice id="takting_invoice">
                <template #invoice_to_address>
                  <b>{{ current_invoice.company_name}}</b> <br>
                  {{ current_invoice.to_address.street }} {{ current_invoice.to_address.building_number }} <br>
                  {{ current_invoice.to_address.zip_code }} {{ current_invoice.to_address.city }} <br>
                  {{ current_invoice.to_address.country }} <br>
                  VAT {{ current_invoice.company_vat }}
                </template>
                <template #invoice_from_address>
                  <b>Seller</b> <br>
                  {{ current_invoice.from_address.custom_information }} <br>
                  {{ current_invoice.from_address.street }} {{ current_invoice.from_address.building_number }} <br>
                  {{ current_invoice.from_address.zip_code }} {{ current_invoice.from_address.city }} <br>
                  {{ current_invoice.from_address.country }} <br>
                  VAT {{ current_invoice.seller_vat }}
                </template>
                <template #invoice_meta_info>
                  <div class="meta-info-row">
                    <div>Project number:</div><div>{{ current_invoice.project_number }}</div>
                  </div>
                  <div class="meta-info-row">
                    <div>Contract number:</div><div>{{ current_invoice.contract_number }}</div>
                  </div>
                  <div class="meta-info-row">
                    <div>Date: </div><div>{{ new Date(current_invoice.created).toDateString() }}</div>
                  </div>
                  <div class="meta-info-row">
                    <div>Invoice number:</div><div>{{ current_invoice.number }}</div>
                  </div>
                  <div class="meta-info-row">
                    <div>Invoice due date:</div><div> {{ current_invoice.invoice_due_date }}</div>
                  </div>
                </template>
                <template #invoice_headline>
                  Invoice {{ current_invoice.project_name }}
                </template>
                <template #invoice_number>
                  {{ current_invoice.number }}
                </template>
                <!-- <template #invoice_qr_info>
                  <div class="qr-code"> </div>
                </template> -->
                <template #invoice_content>
                  <InvoiceContentEntry
                    v-for="invoice_wp in current_invoice.iwork_packages"
                    :key="'invoice_wp' + invoice_wp.id"
                    :work_package="invoice_wp"
                    :preview="false"
                    >
                    <template #invoice_content_entry_note>
                      {{$t('Project.Settings.Pay.Note')}}
                    </template>
                  </InvoiceContentEntry>
                  <InvoiceContentEntry
                    :work_package="{
                      name: 'Sum',
                      costs_only_total: true,
                      costs_total: current_invoice.total_cost
                    }"
                    :preview="false"
                  >
                  <template #invoice_content_entry_note>
                    {{$t('Project.Settings.Pay.Note')}}
                  </template>
                </InvoiceContentEntry>
                </template>
                <template #invoice_content_footer>
                  {{$t('Project.Settings.Pay.InvoiceFooter[0]')}}
                  <br> <br>
                  {{$t('Project.Settings.Pay.InvoiceFooter[1]')}}
                </template>
                <template #invoice_signature>
                  {{ current_invoice.owner.first_name + ' ' + current_invoice.owner.last_name }}
                </template>
                <template #invoice_qr_pay>
                  {{$t('Project.Settings.Pay.CreateInvoice.InvoiceReceived')}} <br>
                  <qrcode-vue :value="'https://takting.com/projects/'+ $route.params.project_id +'/settings/pay/'+ current_invoice.id +'?received=true&code=' + Math.random().toString(36).substring(7)" renderAs="svg" level="H" />
                  <!-- <qrcode-vue :value="'www.raphaelhippe.de'"></qrcode-vue> -->
                  <!-- <div class="qr-code"> </div> -->
                </template>
                <template v-if="current_invoice.footer && current_invoice.footer.upper_row" #invoice_footer_upper_row>
                  <div v-html="current_invoice.footer.upper_row"></div>
                </template>
                <template v-if="current_invoice.footer && current_invoice.footer.left" #invoice_left_footer>
                  <div v-html="current_invoice.footer.left"></div>
                </template>
                <template v-if="current_invoice.footer && current_invoice.footer.middle" #invoice_middle_footer>
                  <div v-html="current_invoice.footer.middle"></div>
                </template>
                <template v-if="current_invoice.footer && current_invoice.footer.right" #invoice_right_footer>
                  <div v-html="current_invoice.footer.right"></div>
                </template>
              </Invoice>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import WorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
import Invoice from '@/components/Invoice/Invoice.component.vue'
import InvoiceContentEntry from '@/components/Invoice/InvoiceContentEntry.component.vue'
import DateCircle from '@/components/ProjectTaktPlan/DateCircle.component.vue'
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import MiniInvoice from '@/components/Invoice/MiniInvoice.component.vue'
import QrcodeVue from 'qrcode.vue';

import {
  mapGetters, mapActions
} from 'vuex';
export default {
  components: {
    WorkPackage,
    Invoice,
    InvoiceContentEntry,
    DateCircle,
    StandardDataField,
    MiniInvoice,
    QrcodeVue,
    StandardBadge
  },
  name: 'ProjectPay',
  data: function() {
    return {
      show_preview: true,
      current_invoice: {},
      selected_twork_packages: [],
      from_address: {
        street: '',
        building_number: '',
        zip_code: '',
        city: '',
        country: '',
      },
      meta_info: {
        project_number: '',
        contract_number: '',
        invoice_number: '',
        invoice_due_date: '',
        seller_vat: ''
      },
      footer_upper_row: '',
      footer_left: '',
      footer_middle: '',
      footer_right: '',
      update_key_invoice: 0,
    }
  },
  computed: {
    ...mapGetters('TWorkPackage', [
      'getInvoiceableTWorkPackages',
      'getInvoicePreview',
      'getInvoice'
    ]),
    ...mapGetters('Project', [
      'getProject',
      'getProjectOwnerInvoices'
    ]),
    ...mapGetters('Auth', [
      'getUser',
    ])
  },
  methods: {
    ...mapActions('TWorkPackage', [
      'requestCreateInvoice',
      'createInvoicePreview'
    ]),
    selectDeselectTWPs(twork_packages){
      for (let i = 0; i < twork_packages.length; i++) {
        const index = this.selected_twork_packages.findIndex(function(item) {
          return item.id == twork_packages[i].id;
        });
        if (index === -1) {
          this.selected_twork_packages.push(twork_packages[i]);
        } else {
          this.selected_twork_packages.splice(index, 1);
        }
      }
    },
    isSelectedTWP(twp){
      const index = this.selected_twork_packages.findIndex(function(item) {
        return item.id == twp.id;
      });
      return index !== -1;
    },
    createInvoicePreviewClick(){
      let payload = {
        project_id: this.$route.params.project_id,
        payload: {twork_packages: [...this.selected_twork_packages]}
      };
      this.createInvoicePreview(payload);
      let project_id = this.$route.params.project_id;
      if (this.getProjectOwnerInvoices(project_id).length > 0) {
        let ref_invoice = this.getProjectOwnerInvoices(project_id)[this.getProjectOwnerInvoices(project_id).length - 1];
        // console.log('ref', ref_invoice, this.getProjectOwnerInvoices);
        this.from_address.street = ref_invoice.from_address.street || '';
        this.from_address.building_number = ref_invoice.from_address.building_number || '';
        this.from_address.zip_code = ref_invoice.from_address.zip_code || '';
        this.from_address.city = ref_invoice.from_address.city || '';
        this.from_address.country = ref_invoice.from_address.country || '';
        this.from_address.custom_information = ref_invoice.from_address.custom_information || '';
        this.meta_info.project_number = ref_invoice.project_number || '';
        this.meta_info.contract_number = ref_invoice.contract_number || '';
        // this.meta_info.invoice_number = ref_invoice.invoice_number || '';
        this.meta_info.invoice_due_date = ref_invoice.invoice_due_date || '';
        this.meta_info.seller_vat = ref_invoice.seller_vat || '';
        this.footer_upper_row = ref_invoice.footer.upper_row;
        this.footer_left = ref_invoice.footer.left;
        this.footer_middle = ref_invoice.footer.middle;
        this.footer_right = ref_invoice.footer.right;
      }

      this.show_preview = true;
    },
    createInvoice(invoice){

      let meta_info = this.meta_info;
      meta_info['company_name'] = this.getInvoicePreview.business.name;

      let payload = {
        project_id: this.$route.params.project_id,
        payload: {
          meta_info: meta_info,
          twork_packages: [...invoice.iwork_packages],
          to_address: this.getInvoicePreview.address.id,
          from_address: this.from_address,
          footer: {
            upper_row: this.footer_upper_row.replace(/\n/g, '<br>'),
            left: this.footer_left.replace(/\n/g, '<br>'),
            middle: this.footer_middle.replace(/\n/g, '<br>'),
            right: this.footer_right.replace(/\n/g, '<br>')
          }
        },
      };
      let self = this;
      this.requestCreateInvoice(payload).then( invoice => {
        self.show_preview = false;
        self.current_invoice = invoice;
      });
    },
    getSumWP(){
      return {
        name: 'Sum',
        costs_only_total: true,
        costs_tendered_total: this.getCostSum()
      };
    },
    getCostSum(){
      let sum = 0;
      let invoice = this.getInvoicePreview;
      for (let i = 0; i < invoice.iwork_packages.length; i++) {
        sum += this.getWPCost(invoice.iwork_packages[i]) + this.sumCostSteps(invoice.iwork_packages[i]);
      }
      return sum;
    },
    getWPCost(wp){
      switch (wp.cost_strategy.id) {
        case 1:
        // 'Flat Rate'
          return wp.costs_tendered_total;
        case 2:
        // 'Unit Price'
          return wp.costs_tendered_material * wp.quantity_value;
        case 3:
        // 'Hourly Wages'
          return (wp.manpower_actual * wp.duration_actual) * wp.manpower_actual * wp.costs_tendered_labour;
        case 4:
        // 'Material Price'
          return wp.costs_tendered_material;
        case 5:
        // 'Material Price and Hourly Wages'
          return ((wp.manpower_actual * wp.duration_actual) * wp.manpower_actual * wp.costs_tendered_labour) + wp.costs_tendered_material;
        default:
          return 0;
      }
    },
    sumCostSteps(wp){
      let sum = 0;
      for (let i = 0; i < wp.cost_steps.length; i++) {
        sum += wp.cost_steps[i].cost;
      }
      return sum;
    },
    setCurrentInvoice(invoice){
      this.current_invoice = invoice;
      this.show_preview = false;
    },
    exportInvoice() {
      // Get HTML to print from element
      const prtHtml = document.getElementById('takting_invoice').innerHTML;

      // Get all stylesheets HTML
      // let stylesHtml = '';
      // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      //   stylesHtml += node.outerHTML;
      // }

      // Open the print window
      const WinPrint = window.open('', 'TAKT.pay', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=1,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          <style type="text/css">
          body {
            background-color: white !important;
            font-size: 4mm;
            padding: 10mm 5mm;
          }
          .qr-code {
            height: 64px;
            width: 64px;
            background-color: blue;
          }
          .invoice {
            width: 210mm;
            font-size: 4mm;
            background-color: white;
            color: black;
            padding: 10px 20px;
          }

          .invoice-row {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 6mm;
          }

          .invoice-content-header {
            display: flex;
            justify-content: space-between;
            width: 100%;
          }

          .invoice-row-right {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            margin-bottom: 6mm;
          }

          .invoice-address {
            line-height: 4mm;
          }

          .invoice-meta-info {
            line-height: 4mm;
          }

          .invoice-logo {
            height: 128px;
            width: 128px;
            background-color: red;
          }

          .invoice-headline {
            font-weight: bold;
          }

          .invoice-number {
            font-weight: bold;
          }

          .invoice-qr-info {
            font-size: 4mm;
          }

          .invoice-qr-info div {
            float: right;
          }

          .invoice-content {
            width: 100%;
          }

          .invoice-content-footer {

          }

          .invoice-signature {

          }

          .invoice-signature-line {
            width: 50mm;
            margin-top: 50px;
            margin-bottom: 15px;
          }

          .invoice-qr-pay {
            font-size: 4mm;
          }

          .invoice-qr-pay div {
            float: right;
          }

          .invoice-footer {
            color: grey;
            font-size: 3mm;
          }

          .invoice-takting-footer {

          }

          .invoice-entry {
            background-color: #f5f5f5;
            padding: 5px;
            margin-bottom: 2px;
            display: block;
            page-break-inside: avoid;
          }

          .invoice-entry-header {
            display: flex;
            justify-content: space-between;
            font-size: 4mm;
            font-weight: bold;
          }

          .invoice-entry-content {
            font-size: 4mm;
          }

          .invoice-70 {
            width: 70%;
          }

          .invoice-20 {
            width: 20%;
          }

          .invoice-10 {
            width: 10%;
          }

          .invoice-text-right {
            text-align: right;
          }

          .meta-info-row {
            display: flex;
            justify-content: space-between;
            width: 64mm;
            font-size: 4mm;
            line-height: initial;
          }

          .cost-step {
            display: flex;
            justify-content: space-between;
          }

          </style>
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(function() {
      WinPrint.print();
      WinPrint.close();
    }, 1500);
    }
  }
}
</script>

<style lang="scss" scoped>
.members-setting-default-height {
  height: 665px;
  overflow-y: auto;
}
.invoice-setting-default-height {
  height: 300px;
  overflow-y: auto;
}
.wp-list {
  display: flex;
  overflow-x: auto;
  align-items: flex-start;
}
.qr-code {
  height: 64px;
  width: 64px;
  background-color: blue;
}
.date-circle-wrapper {
  position: sticky;
  position: -webkit-sticky;
  display: flex;
  width: 62px;
  height: 62px;
  // width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
  // height: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom));
  max-height: 75px;
  // background-color: var(--v-color-4-base);
  padding: 5px;
  // border-style: solid;
  // border-color: var(--header_border_color);
  // border-width: 1px 1px 1px 0px;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.my-mini-invoice {
  margin: 5px;
}

.mini-invoice-row {
  display: flex;
  justify-content: left;
  width: 100%;
  flex-wrap: wrap;
}

.from-address-row {
  display: flex;
  justify-content: space-between;
  width: 60mm;
  font-size: 4mm;
}

.meta-info-row {
  display: flex;
  justify-content: space-between;
  width: 64mm;
  font-size: 4mm;
  line-height: initial;
}
</style>
